<script setup lang="ts">
import type { ComponentBrandProductsBannerProps } from "./ComponentBrandProductsBanner.props"
import { mapProducts } from "~/utils/mapProducts"
const props = defineProps<ComponentBrandProductsBannerProps>()

let brandProductsBanner: ComponentBrandProductsBannerProps = {
  ...props
}
const { $cl } = useNuxtApp()
const dataProducts = await productsPrice($cl, props.products)
brandProductsBanner.products = mapProducts(dataProducts, null, "CONTENTFUL")
</script>

<template>
  <div class="cms-brand-products-banner py-10">
    <ProductBlocksBrandsOrganismProducts
      v-if="brandProductsBanner && brandProductsBanner.products.length > 0"
      v-bind="brandProductsBanner"
    />
  </div>
</template>
